<template>
  <v-row>
    <v-col cols="12">
      <vuetify-table
        :headers="headers"
        :api-u-r-l="apiURL"
        :readonly="true"
        :title="title"
        :bus="bus"
        permisosEliminar="eliminar_licencia"
      >
        <template v-slot:footer>
          <v-row
            v-if="!showAdd"
            class="mx-2"
            justify="space-around"
          >
            <v-col>
              <v-btn
                :loading="loadServices"
                color="success"
                @click="showServices()"
              >
                Agregar Paquetes
              </v-btn>
            </v-col>
          </v-row>

          <!-- Selector de Servicio -->
          <v-row
            v-else
            class="mx-2"
            justify="center"
          >
            <v-col>
              <v-autocomplete
                v-model="service"
                :items="filteredServices"
                item-value="id"
                item-text="nombre"
                label="Tipo de Paquetes"
                return-object
                @input="searchServices"
                :loading="serviceLoading"
                :search-input.sync="search"
                clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                    :color="getColor(data.item.available)"
                    dark
                  >
                    <span v-if="data.item.available >= 1">
                      {{ data.item.service }} - {{ data.item.name }}
                      ({{ data.item.quantity }} Cantidad - {{ data.item.time }} meses)
                      Disponibles {{ data.item.available }}
                    </span>
                    <span v-else>
                      {{ data.item.service }} - {{ data.item.name }}
                      ({{ data.item.quantity }} Cantidad - {{ data.item.time }} meses)
                      Disponibles {{ data.item.available }}
                    </span>
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  {{ data.item.service }} - {{ data.item.name }}
                  ({{ data.item.quantity }} Cantidad - {{ data.item.time }} meses)
                  Disponibles {{ data.item.available }}
                </template>
              </v-autocomplete>
            </v-col>
            <v-col>
              <v-btn
                color="blue darken-1"
                :loading="serviceLoading"
                @click="assignService()"
              >
                Asignar
              </v-btn>
            </v-col>
          </v-row>
        </template>

        <!-- Acciones sobre los ítems de la tabla -->
        <template v-slot:actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon
                color="blue darken-1"
                dark
                @click="openModalDelete(item)"
                v-on="on"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
        </template>

        <!-- Configuración visual específica de la tabla -->
        <template v-slot:item.name>
          <span>APP</span>
        </template>
      </vuetify-table>
    </v-col>

    <!-- Diálogo de confirmación para eliminar registros -->
    <v-dialog
      v-model="dialog"
      max-width="620"
    >
      <v-card>
        <v-card-title class="headline">
          ¿Estás seguro de que quieres eliminar este registro?
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            :loading="toggleStatusDelete"
            @click.prevent="deleteItem()"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import Vue from 'vue';
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  components: {
    VuetifyTable,
  },
  props: {
    enterpriseId: { default: '' },
    dealerId: { default: '' },
  },
  data: () => ({
    name: '',
    service: null,
    servicesList: [],
    filteredServices: [],
    search: '',
    debounceTimer: null,
    serviceLoading: false,
    showAdd: false,
    loadServices: false,
    total: 0,
    bus: new Vue(),
    dialog: false,
    toggleStatusDelete: false,
    item: null,
    headers: [
      { text: 'Servicio', value: 'name', align: 'left', sortable: true },
      { text: 'Licencia', value: 'code', align: 'left', sortable: true },
      { text: 'Tiempo (Meses)', value: 'time', align: 'left', sortable: true },
      { text: 'Total', value: 'total', align: 'left', sortable: true },
      { text: 'Fecha de Asignación', value: 'created_at', sortable: true },
      { text: 'Fecha Inicio', value: 'date_start', sortable: true },
      { text: 'Fecha Fin', value: 'date_end', sortable: true },
      { text: 'Estado', value: 'active', sortable: true },
      { text: 'Acciones', value: 'action' },
    ],
  }),

  computed: {
    apiURL() {
      return `/api/enterprises/${this.enterpriseId}/licence`;
    },
    title() {
      return 'Paquetes';
    },
  },

  watch: {
    search() {
      this.searchServices();
    },
  },

  mounted() {
    this.fetchAllServices();
  },

  methods: {
    fetchAllServices() {
      let url;

      if (this.dealerId) {
        url = `/api/catalogs/dealers/${this.dealerId}/enterprises/${this.enterpriseId}/licences`;
      } else {
        url = `/api/catalogs/services/list/${this.enterpriseId}`;
      }
      window.axios.get(url)
        .then((result) => {
          this.servicesList = result.data.items;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error('Error fetching services:', error);
        });
    },

    showServices() {
      if (this.servicesList.length === 0) {
        this.fetchAllServices();
      }
      this.showAdd = !this.showAdd;
    },

    assignService() {
      if (!this.service) return;
      this.serviceLoading = true;
      const total = this.servicesList.find((s) => s.id === this.service.id).quantity;
      const data = {
        service: this.service.id,
        enterprise_id: this.enterpriseId,
        total,
        type: 'E',
      };
      if (this.dealerId) {
        data.dealer = this.dealerId;
      }
      window.axios.post('/api/licences/associate', data)
        .then(() => {
          this.serviceLoading = false;
          this.bus.$emit('refreshTable');
          this.showAdd = !this.showAdd;
          this.servicesList = [];
          this.fetchAllServices();
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error('Error assigning service:', error);
          this.serviceLoading = false;
        });
    },

    searchServices() {
      // Limpia el timer de debounce si ya existe uno
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }
      // Función para realizar la búsqueda después del debounce
      const doSearch = () => {
        if (this.search && this.search.length >= 3) {
          const url = `/api/catalogs/services/list/${this.enterpriseId}?search=${this.search}`;
          window.axios.get(url)
            .then((result) => {
              this.filteredServices = result.data.items;
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.error('Error fetching services:', error);
            });
        } else {
          const url = `/api/catalogs/services/list/${this.enterpriseId}`;
          window.axios.get(url)
            .then((result) => {
              this.filteredServices = result.data.items;
            })
            .catch((error) => {
              // eslint-disable-next-line
              console.error('Error fetching services:', error);
            });
        }
      };

      // Configura un nuevo timer de debounce para esperar 300 ms después de la última pulsación de tecla
      this.debounceTimer = setTimeout(doSearch, 300);
    },
    getColor(available) {
      return available >= 1 ? 'green' : 'red';
    },
    openModalDelete(item) {
      this.dialog = true;
      this.item = item;
    },
    deleteItem() {
      this.toggleStatusDelete = true;
      const url = `${this.apiURL}/${this.item.id}`;
      window.axios.delete(url)
        .then((response) => {
          // eslint-disable-next-line
          console.log(response);
          this.$store.dispatch('snackbar/success', 'Registro eliminado correctamente');
          this.toggleStatusDelete = false;
          this.dialog = false;
          this.bus.$emit('refreshTable');
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error('Error deleting item:', error);
          this.$store.dispatch('snackbar/error', 'Error al eliminar el registro');
          this.toggleStatusDelete = false;
          this.dialog = false;
        });
    },
  },
};
</script>
